export const items = [
  {
    title: 'banana',
    code: '4011',
  },
  {
    title: 'avocado',
    code: '4223',
  },
  {
    title: 'kiwi Golden',
    code: '3279',
  },
  {
    title: 'kiwi Green',
    code: '4030',
  },
  {
    title: 'lemons',
    code: '4053',
  },
  {
    title: 'ginger root',
    code: '4612',
  },
  {
    title: 'kale black',
    code: '3095',
  },
  {
    title: 'onion white',
    code: '4663',
  },
  {
    title: 'garlic white',
    code: '4608',
  },
  {
    title: 'eggplant',
    code: '4081',
  },
  {
    title: 'Granny smith',
    code: '4017',
  },
  {
    title: 'honey crisp',
    code: '3283',
  },
  {
    title: 'pepper',
    code: '4690',
  },
  {
    title: 'potato',
    code: '4727',
  },
  {
    title: 'tomato',
    code: '4664',
  },
  {
    title: 'mushroom',
    code: '4649',
  },
  {
    title: 'potato red',
    code: '4073',
  },
  {
    title: 'cucumber',
    code: '4593',
  },
  {
    title: 'carrot',
    code: '4620',
  },

]